import { useEffect, useState } from 'react';

interface HeaderProps {
  userInfo?: {
    honmeisei: string;
    nikkan: string;
    nikkan_gogyou?: string;
  };
}

export function Header({ userInfo }: HeaderProps) {
  const [dark, setDark] = useState<boolean>(() => {
    if (typeof window === 'undefined') return false;
    const stored = window.localStorage.getItem('unsei.theme');
    if (stored === 'dark') return true;
    if (stored === 'light') return false;
    return window.matchMedia('(prefers-color-scheme: dark)').matches;
  });

  useEffect(() => {
    const root = document.documentElement;
    root.classList.toggle('dark', dark);
    window.localStorage.setItem('unsei.theme', dark ? 'dark' : 'light');
  }, [dark]);

  return (
    <header className="sticky top-0 z-20 backdrop-blur bg-ink-50/90 dark:bg-ink-900/85 border-b border-ink-200/60 dark:border-ink-700/60">
      <div className="max-w-device w-full mx-auto px-4 py-3 flex items-baseline gap-3">
        <h1 className="font-serif text-xl font-bold tracking-widest text-ink-900 dark:text-ink-50">
          運<span className="text-gold-500">勢</span>
        </h1>
        {userInfo && (
          <p className="text-xs text-ink-500 dark:text-ink-300">
            {userInfo.honmeisei} ／ {userInfo.nikkan}日
            {userInfo.nikkan_gogyou && <span className="opacity-70">({userInfo.nikkan_gogyou})</span>}
          </p>
        )}
        <button
          aria-label={dark ? 'ライトモードへ切替' : 'ダークモードへ切替'}
          onClick={() => setDark((v) => !v)}
          className="ml-auto h-8 w-8 grid place-items-center rounded-full
                     text-ink-600 dark:text-ink-200 hover:bg-ink-200/60 dark:hover:bg-ink-700/60
                     transition-colors"
        >
          <span aria-hidden>{dark ? '☾' : '☀'}</span>
        </button>
      </div>
    </header>
  );
}
